import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { useLocalizationStore } from '@stores/localizationStore';
import { getDirection } from '@workpay/ds-shared/utils/direction';
import '@styles/global.scss';

// Formio file-provider registers lazily via loadFormioReact() — don't add
// an eager call here, it pulls @formio/js into the boot graph.

// Apply <html dir> + <html lang> from current language. Runs before React
// mounts so the first paint already has the correct direction (no LTR
// flash for RTL users), and on every store change via subscribe.
function applyDirection(language: string) {
  const dir = getDirection(language);
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', language);
}

applyDirection(useLocalizationStore.getState().language);
useLocalizationStore.subscribe((state) => applyDirection(state.language));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Remove the static bootstrap loader once React mounts — GlobalLoader picks
// up the session-fetch window with the same mark.
requestAnimationFrame(() => {
  document.getElementById('app-loader')?.remove();
});
